module.exports = __webpack_public_path__ + "news-4a753f38/video-c942510ba422e55ebbc79788086e1b55.svg";